import { decryption } from "./encryption/encryption";

export const isUserInfoExist = (object: Object | Storage) => {
  return Object.keys(object).findIndex(
    (element) => decryption(element) === "user"
  );
};

// TODO: 여기서 decryption(element) === "user" 이게 아닌 모든 쿠키는 지우는 코드를 넣어보자.
